import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useUnilevelLegsLogic } from './UnilevelLegsLogic';
import BasicUnilevelLegsSkin from './skins/BasicUnilevelLegsSkin';

export const UnilevelLegsSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.UNILEVEL_LEGS,
  name: '유니레벨 레그',
  category: 'mlm',
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicUnilevelLegsSkin as any
  },
  useLogic: useUnilevelLegsLogic as any,
  defaultProps: {
    // 스킨 옵션
    title: '추천 레그',
    emptyText: '데이터가 없습니다',
    loadingText: '조직도를 불러오는 중입니다...',
    errorText: '데이터를 불러오는데 실패했습니다',
    loginRequiredText: '로그인이 필요한 서비스입니다.',
    
    // 표시 옵션
    showNavigationButtons: true,
    showBreadcrumb: true,
    showDebugMode: false,
    showZoomControls: true,
    
    // 노드 정보 표시 옵션
    showNodePV: true,
    showNodeRank: true,
    showNodeGrade: true,
    showNodePhone: true,
    showNodeCenter: true,
    showNodeGroupPV: true,
    showMoreButton: true,
    
    // 줌 설정
    initialZoom: 1,
    minZoom: 0.3,
    maxZoom: 2.5,
    
    // 색상 테마
    lineColor: '#3f51b5',
    nodeBackgroundColor: '#ffffff',
    nodeBorderColor: '#e0e0e0',
    nodeShadow: '0 2px 4px rgba(0,0,0,0.1)',
    titleBackgroundColor: '#3f51b5',
    titleTextColor: '#ffffff',
    contentTextColor: '#333333',
    bubbleBadgeColor: '#2196f3',
    bubbleBadgeTextColor: '#ffffff',
    
    // 버튼 색상
    buttonPrimaryColor: '#3f51b5',
    buttonSecondaryColor: '#6c757d',
    buttonSuccessColor: '#28a745',
    buttonDangerColor: '#dc3545',
    
    // 컨테이너 스타일
    containerBackgroundColor: '#ffffff',
    breadcrumbColor: '#666666',
    breadcrumbActiveColor: '#3f51b5'
  }
};